export const GET_BIKES_FILTER_FAILURE="GET_BIKES_FILTER_FAILURE"
export const GET_BIKES_FILTER_REQUEST="GET_BIKES_FILTER_REQUEST"
export const GET_BIKES_FILTER_SUCCESS="GET_BIKES_FILTER_SUCCESS"